import type {ButtonProps} from "@chakra-ui/react";
import {IconButton as ChakraIconButton} from "@chakra-ui/react";
import * as React from "react";
import useTranslate from "platformed-components/i18n/useTranslate";
import {LuX} from "react-icons/lu";

export type CloseButtonProps = ButtonProps;

export const CloseButton = React.forwardRef<HTMLButtonElement, CloseButtonProps>(function CloseButton(props, ref) {
  const t = useTranslate();
  return (
    <ChakraIconButton variant="ghost" aria-label={t("c.Close")} ref={ref} {...props}>
      {props.children ?? <LuX />}
    </ChakraIconButton>
  );
});
